/**
 * Self Exclusion View
 */

define(function(require, exports, module) {
    'use strict';
    const Form = require('class/form.class');
    const BaseView = require('common/base.view');
    const dispatcher = require('bundle').dispatcher;
    const SelfExclusionModel = require('portlets/responsible-gaming/self-exclusion/self-exclusion.model');

    module.exports = BaseView.extend({

        events: {
            'change .fn-period': 'toggleEndDateAction',
            'submit form': 'submitHandler',
            'tap .fn-revoke': 'revokeHandler'
        },

        initialize: function(options) {
            this.options = options;
            this.model = new SelfExclusionModel(this.options);
        },

        render: function() {
            this.$el.html(this.tmpl('self-exclusion'));
            this.model.fetch()
                .done(this.insertForm.bind(this))
                .fail(this.renderNetworkError.bind(this));

            return this;
        },

        insertForm: function() {
            this.$('.fn-exclude-form').html(this.tmpl('self-exclusion.form', this.model.toJSON()));

            if (this.model.get('isExclusionFormAllowed')) {
                this.form = new Form(this.$('form'), {
                    validationConfig: this.model.validationConfig
                });

                this.toggleEndDateAction();
                this.form.wrapFormControls();
            }
        },

        renderEndTypes: function() {
            this.$('.fn-endTypes').html(this.tmpl('self-exclusion.endTypes', this.model.toJSON()));

            this.form.wrapFormControls();
        },

        toggleEndDateAction: function() {
            var $endDateField = this.$('.fn-enddate');
            var value = this.form.data('period');

            this.model.set('isOpenEnded', value === 'Open ended');

            this.renderEndTypes();

            $endDateField.toggleClass('hidden', value !== 'enddate');
        },

        submitHandler: function(event) {
            event.preventDefault();

            return this.form.validate()
                .done((data) => this.excludeAction(data));
        },

        excludeAction: function(data) {
            this.hideKeyboard();
            this.form.showLoading();

            this.model.save(data)
                .done(() => this.successExclude())
                .fail((error) => this.errorExclude(error, data, this.excludeAction.bind(this)))
                .always(() => this.form.hideLoading());
        },

        successExclude: function() {
            dispatcher.dispatch('self-exclusion-success');

            this.model.fetch()
                .done(function(data) {
                    this.insertForm(data);

                    this.showInfo({
                        content: this.translate('playtech.mobile.ngresponsiblegaming.self-exclusion.exclusionSuccessful')
                    });
                }.bind(this))
                .fail(this.renderNetworkError.bind(this));
        },

        errorExclude: function(response, initialRequestData, retryAction) {
            var MINIMUM_PERIOD_EXCEEDED_ERROR_CODE = 1810;
            var MAXIMUM_PERIOD_EXCEEDED_ERROR_CODE = 1809;
            var data = response.data;
            var errorCode = data.errorCode;

            if (errorCode === 303) {
                this.showTwoFactorAuthPopup(initialRequestData, retryAction);

                return;
            } else if (errorCode === MINIMUM_PERIOD_EXCEEDED_ERROR_CODE) {
                errorCode = errorCode + '.' + this.model.get('minimumAllowedPeriod');
            } else if (errorCode === MAXIMUM_PERIOD_EXCEEDED_ERROR_CODE) {
                errorCode = errorCode + '.' + this.model.get('maximumAllowedPeriod');
            }

            this.form.showErrorMessage({
                translation: 'playtech.mobile.ngresponsiblegaming.self-exclusion.error.' + (errorCode || 'default'),
                content: data.errorMessage
            });
        },

        revokeHandler: function(event) {
            const data = {
                revokeProduct: event.target.dataset.revokeProduct
            };

            this.revokeAction(data);
        },

        revokeAction: function(data) {
            this.model.save(data)
                .done(() => this.successRevoke())
                .fail((error) => this.errorRevoke(error, data, this.revokeAction.bind(this)));
        },

        successRevoke: function() {
            this.model.fetch()
                .done(function(data) {
                    this.insertForm(data);

                    window.Playtech.API.popup.showPopup({
                        title: this.translate('playtech.mobile.ngresponsiblegaming.self-exclusion.revokeSuccessTitle'),
                        content: this.translate('playtech.mobile.ngresponsiblegaming.self-exclusion.revokeSuccessDescription')
                    });
                }.bind(this))
                .fail(this.renderNetworkError.bind(this));
        },

        errorRevoke: function(response, initialRequestData, retryAction) {
            if (response?.data?.errorCode === 303) {
                this.showTwoFactorAuthPopup(initialRequestData, retryAction);

                return;
            }

            window.Playtech.API.popup.showPopup({
                title: this.translate('playtech.mobile.ngresponsiblegaming.self-exclusion.revokeErrorTitle'),
                content: this.translate('playtech.mobile.ngresponsiblegaming.self-exclusion.revokeErrorDescription')
            });
        },

        showTwoFactorAuthPopup: function(initialRequestData, retryAction) {
            dispatcher.dispatch('app:message', {
                ID: 'twoFactorAuthentication',
                data: {
                    onCancel: () => {
                        dispatcher.dispatch('2fa-popup-closed', 'rg-self-exclusion');
                    },
                    onSuccess: () => retryAction(initialRequestData),
                    resendHandler: () => this.model.save(initialRequestData)
                }
            });
        }
    });
});
